import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { RequestActionPrefix } from '../../request/types'
import * as Types from './types'

export const sortState = <T extends Types.SortableObject>(data: T[], sort: SortDescriptor[]): T[] => {
  return orderBy(data, sort)
}

export const sortTableConstant = (prefix: RequestActionPrefix) => `${prefix}_SORT_TABLE`



// WEBPACK FOOTER //
// ./src/components/sortable/utils.ts